module.exports = __webpack_public_path__ + "static/media/uib6.1ce2237c.png";